var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 28C9.3724 28 4 22.6276 4 16C4 9.3724 9.3724 4 16 4C22.6276 4 28 9.3724 28 16C28 22.6276 22.6276 28 16 28ZM16 25.6C18.5461 25.6 20.9879 24.5886 22.7882 22.7882C24.5886 20.9879 25.6 18.5461 25.6 16C25.6 13.4539 24.5886 11.0121 22.7882 9.21178C20.9879 7.41143 18.5461 6.4 16 6.4C13.4539 6.4 11.0121 7.41143 9.21178 9.21178C7.41143 11.0121 6.4 13.4539 6.4 16C6.4 18.5461 7.41143 20.9879 9.21178 22.7882C11.0121 24.5886 13.4539 25.6 16 25.6ZM14.8 10H17.2V12.4H14.8V10ZM14.8 14.8H17.2V22H14.8V14.8Z",
    fill: "#111111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoBlack);
export default __webpack_public_path__ + "static/media/info-black.7941240ca3224c3ceb25275584d277b9.svg";
export { ForwardRef as ReactComponent };